export class HttpError extends Error {
    public statusCode: number;
    public status: string;
    public errorCode: string;
  
    public constructor(statusCode: number, message: string, options?: ErrorOptions) {
      super(message, options);
  
      Object.setPrototypeOf(this, HttpError.prototype);
      this.statusCode = statusCode;
      this.status = (options?.cause as { status?: string })?.status ?? '';
      this.message = message;
      this.errorCode = (options?.cause as { errorCode?: string })?.errorCode ?? '';
    }
  }